module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/modal/modal-finalizar-matricula/modal-finalizar-matricula.component.css
// module id = ./src/app/shared/modal/modal-finalizar-matricula/modal-finalizar-matricula.component.css
// module chunks = main